module.exports = __webpack_public_path__ + "img/logo.453a492e.png";